<template>
    <o-modal name="confirmation" class="o-confirmationModal">
        <slot></slot>

        <template v-slot:actions>
            <div class="o-confirmationModal__actions">
                <a-button
                    class="o-confirmationModal__actionButton"
                    @click="$emit('abort')"
                    >Nie</a-button
                >
                <a-button
                    class="o-confirmationModal__actionButton"
                    @click="$emit('approve')"
                    >Tak</a-button
                >
            </div>
        </template>
    </o-modal>
</template>

<script>
export default {
    name: 'ConfirmationModal'
}
</script>
